export default {
  geolocation: {
    lat: '52.2337',
    lng: '21.0716',
    label: '00-001 Warsaw',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
